export enum MenuRoutes {
	Authentication = "/authentication",
	Login = "login",
	LoginMultitenant = "login-multitenant",
	LoginUnguarded = "login-unguarded",
	Dashboard = "/dashboard",
	Calls = "/calls",
	Queues = "queues",
	NewQueue = "queues/new",
	EditQueue = "queues/:queueId",
	Flows = "flows",
	NewFlow = "flows/new",
	EditFlow = "flows/:flowId",
	DesignFlow = "flows/design/:flowId",
	TextDesignFlow = "flows/design/:flowId/:channelType",
	NewAppInstance = "appinstances/new",
	EntryPoints = "entrypoints",
	NewEntryPoint = "entrypoints/new",
	EditEntryPoint = "entrypoints/:entryPointId",
	Generic = "/generic",
	UserManagement = "/usermanagement",
	Users = "/usermanagement/users",
	EditUser = "users/:userId",
	EditMember = "users/:userId/:queueType/:queueId",
	AiAgents = "/usermanagement/ai-agents",
	InsightsUsers = "/usermanagement/insights-users",
	NewAiAgent = "ai-agents/new",
	EditAiAgent = "ai-agents/:agentId",
	GeneralSettings = "/generalsettings",
	Contacts = "/contacts",
	Schedules = "/schedules",
	NewSchedule = "/schedules/new",
	EditSchedule = "/schedules/:scheduleId",
	Events = "/events",
	NewEvent = "/events/new",
	EdiEvent = "/events/:eventId",
	Announcements = '/announcements',
    NewAnnouncement = '/announcements/new',
    EditAnnouncement = '/announcements/:announcementId',
    EditDynamicMediaFile = '/announcements/:announcementId/:dynamicId',
	WrapUp = "/wrapup",
	NewWrapUp = "/wrapup/new",
	EditWrapUp = "/wrapup/:wrapUpCollectionId",
	Account = "account",
	Tenants = "/tenants",
	NewTenant = "/tenants/new",
	EditTenant = "/tenants/:tenantId",
	Forbidden = "/403",
	Skills = "/skills",
	NewSkill = "/skills/new",
	EditSkill = "/skills/:skillId",
	Tags = "/tags",
	NewTag = "/tags/new",
	EditTag = "/tags/:tagId",
	Text = "/text",
	Templates = "/templates",
	NewTemplate = "/templates/new",
	EditTemplate = "/templates/:templateId",
	AIPrompts = "/aiprompts",
	NewAIPrompt = "/aiprompts/new",
	EditAIPrompts = "/aiprompts/:templateId",
	Setup = "/setup",
	Integrations = "/setup/integrations",
	ApiDocumentation = "/api-documentation",
	DataRetentions = "/data-retention",
	Knowledge = "/knowledge",
	NewKnowledgeDocument = "/knowledge/new",
	EditKnowledgeDocument = "/knowledge/:documentId",
	McpServers = "/mcp-servers",
	NewMcpServer = "/mcp-servers/new",
	EditMcpServer = "/mcp-servers/:mcpServerId",
	Subscriptions = "/subscriptions",
	Recordings = "/recordings",
}
